import request from '../request';

const baseUrl = request.getBaseUrl();
const urlPre = '/transaction-center/';
// const urlPre = '/'
const server = {
  fileUpload: `${baseUrl}/product/fileUploadForProductImage`,
  enquiryPrice_fileUpload: `${baseUrl}/transaction-center/Enquiry/fileUpload`,
  // 收费通知单 附件上传
  fileUploadForChargeNotice: `${baseUrl}/transaction-center/upload/chargeNotice`,
  // 下单页上传大型图片
  videoUploadUrl: `${baseUrl}/cms/cms/orderAttachUpload`,
  fileUploadForGreenPdfAndPic: `${baseUrl}/user-center/oss/fileUploadForGreenPdfAndPic`,

  queryOrderList(params) {
    return request.post(`${urlPre}supplier/listOrder`, params);
  },

  // 针对生产 特定供应商临时调用 订单列表接口
  queryEMaoListOrder(params) {
    return request.post(`${urlPre}supplier/queryEMaoListOrder`, params);
  },

  queryOrderDetail(params) {
    return request.post(`${urlPre}supplier/getOrder`, params);
  },
  queryOrderSkuList(params) {
    return request.post(`${urlPre}orderSku/listSupplierSku`, params);
  },
  // 附件上传获取的清单
  queryAttachment(params) {
    return request.fetch(
      `${urlPre}categoryReview/queryCategoryReviewAttachmentByCategoryId`,
      params
    );
  },
  queryShipOrderDetail(params) {
    return request.post(`${urlPre}supplier/getShipOrder`, params);
  },
  queryConfirmOrderList(params) {
    return request.post(`${urlPre}orderSku/listConfirm`, params);
  },
  supplierConfirmOrder(params) {
    return request.post(`${urlPre}supplier/confirmOrder`, params);
  },
  supplierShipOrder(params) {
    return request.post(`${urlPre}supplier/shipOrder`, params);
  },

  // 供应商运营后台---售后单审核列表
  queryAftersalesListForAudit(params) {
    return request.post(`${urlPre}refund/queryAftersalesListForAudit`, params);
  },

  // 供应商运营后台---根据aftersalesId查看商品详情
  queryAftersalesSkuPage(params) {
    return request.post(`${urlPre}refund/queryAftersalesSkuPage`, params);
  },
  // 图片列表
  queryAftersalesAttach(params) {
    return request.post(`${urlPre}refund/queryAftersalesAttach`, params);
  },

  // 采购商撤回申请
  callbackAftersales(params) {
    return request.post(`${urlPre}/refund/callbackAftersales`, params);
  },

  // 供应商审核通过
  auditAftersales(params) {
    return request.post(`${urlPre}/refund/auditAftersales`, params);
  },
  // 发票清单列表
  page(params) {
    return request.post(`${urlPre}invoiceListSupplier/page`, params);
  },
  // 供应商寄送发票
  sendInvoice(params) {
    return request.post(`${urlPre}invoiceListSupplier/sendInvoice`, params);
  },
  // 供应商确认发票
  receiveInvoice(params) {
    return request.post(`${urlPre}invoiceListSupplier/receiveInvoice`, params);
  },
  // 供应商确认发票
  submitElectronicInvoice(params) {
    return request.post(
      `${urlPre}invoiceListSupplier/submitElectronicInvoice`,
      params
    );
  },
  // 发票清单-详情查询
  detail(params) {
    return request.post(`${urlPre}invoiceListSupplier/detail`, params);
  },
  // 发票清单-详情查询
  orderList(params) {
    return request.post(`${urlPre}invoiceListSupplier/orderList`, params);
  },
  // 查询收货单
  listOrderReceiveName(params) {
    return request.post(`${urlPre}receive/listOrderReceiveName`, params);
  },

  // 评价列表 之后抽出来
  queryFeedbackManagementList(params) {
    return request.post(
      'evaluation/evaluation/queryFeedbackManagementList',
      params
    );
  },
  // 新增评价
  addMoreFeedback(params) {
    return request.post('evaluation/evaluation/addMoreFeedback', params);
  },
  listShipOrder(params) {
    return request.post(`${urlPre}supplier/listShipOrder`, params);
  },
  listSelfMentionShip(params) {
    return request.post(`${urlPre}supplier/listSelfMentionShip`, params);
  },
  // 查询物流单
  queryLogisticsList(params) {
    return request.post('logistics/logistics/queryLogisticsList', params);
  },
  // 自配保存物流轨迹
  saveLogisticsTrack(params) {
    return request.post('logistics/logistics/saveLogisticsTrack', params);
  },
  // 查询供应商绑定的物流商
  queryCompanyTransport(params) {
    return request.post('user-center/company/queryCompanyTransport', params);
  },
  // 查询供应商绑定的物流商   仅限快递快运
  selectExpressCompanyByBillNo(params) {
    return request.fetch(
      'logistics/logistics/selectExpressCompanyByBillNo',
      params
    );
  },
  // 获取地区信息   仅限快递快运
  queryByParentId(params) {
    return request.post('user-center/area/queryByParentId', params);
  },
  // 采购订单汇总--采购订单列表
  queryPurchaseOrderListByPage(params) {
    return request.post(
      `${urlPre}OrderStatistic/queryPurchaseOrderListByPage`,
      params
    );
  },
  // 采购订单汇总--订单操作记录
  queryPurchaseOrderLogByPage(params) {
    return request.post(
      `${urlPre}OrderStatistic/queryPurchaseOrderLogByPage`,
      params
    );
  },
  // 采购订单汇总--订单明细
  queryPurchaseOrderSkuListByPage(params) {
    return request.post(
      `${urlPre}OrderStatistic/queryPurchaseOrderSkuListByPage`,
      params
    );
  },
  // 采购订单汇总--订单明细
  orderChangeQuery(params) {
    return request.post(`${urlPre}orderChange/orderChangeQuery`, params);
  },
  // 订单变更审核
  orderChangeAudit(params) {
    return request.post(`${urlPre}orderChange/orderChangeAudit`, params);
  },
  // 订单取消审核
  cancelConfirm(params) {
    return request.post(`${urlPre}supplier/cancelConfirm`, params);
  },
  // 导出售后单列表
  downloadAftersalesAuditList(params) {
    return request.post(
      `${urlPre}refundExport/downloadAftersalesAuditList`,
      params,
      {
        responseType: 'blob',
      }
    );
  },
  grtListSupplierSku(params) {
    return request.post(`${urlPre}orderSku/listSupplierSku`, params);
  },
  purchaseOrderStatistic(params) {
    return request.post(`${urlPre}OrderStatistic/countOrder`, params);
  },
  // 订单列表导出订单明细
  exportSupplierOrderSkuList(params) {
    return request.post(
      `${urlPre}OrderStatistic/exportSupplierOrderSkuList`,
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 订单列表导出订单概要
  exportSupplierOrderList(params) {
    return request.post(
      `${urlPre}OrderStatistic/exportSupplierOrderList`,
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 发货单列表
  spplierShipList(params) {
    return request.post(`${urlPre}receive/supplierShipList`, params);
  },
  // 发货单详情
  supplierShipDetail(params) {
    return request.post(`${urlPre}receive/supplierShipDetail`, params);
  },
  // 发货单详情列表
  supplierShipItemList(params) {
    return request.post(`${urlPre}receiveItem/supplierShipItemList`, params);
  },
  // 订单详情-删除收发货单
  removeShipInfo(params) {
    return request.post(`${urlPre}receive/removeShipInfo`, params);
  },
  // 新增发货人信息
  addOrderDelivery(params) {
    return request.post(`${urlPre}OrderDelivery/addOrderDelivery`, params);
  },
  // 查询发货人信息   模糊查询  发货人管理
  queryOrderDeliveryByPage(params) {
    return request.post(
      `${urlPre}OrderDelivery/queryOrderDeliveryByPage`,
      params
    );
  },
  // 查询发货人信息   精确查询  发货页面
  queryOrderDelivery(params) {
    return request.post(`${urlPre}/OrderDelivery/queryOrderDelivery`, params);
  },
  // 编辑发货人信息
  modifyOrderDelivery(params) {
    return request.post(`${urlPre}OrderDelivery/modifyOrderDelivery`, params);
  },
  // 删除发货人信息
  removeOrderDelivery(params) {
    return request.post(`${urlPre}OrderDelivery/removeOrderDelivery`, params);
  },
  // 获取最新的一次发货人信息
  getLatestTimeDelivery(params) {
    return request.post(`${urlPre}supplier/getLatestTimeDelivery`, params);
  },
  // 询价列表
  queryAuditEnquiryListByPage(params) {
    return request.post(`${urlPre}Enquiry/queryAuditEnquiryListByPage`, params);
  },
  // 公开询价
  queryPublicSupplierOfferList(params) {
    return request.post(
      `${urlPre}Enquiry/queryPublicSupplierOfferList`,
      params
    );
  },
  // 定向询价
  querySupplierOfferList(params) {
    return request.post(`${urlPre}Enquiry/querySupplierOfferList`, params);
  },
  // 查询询价单详情
  queryEnquiryDetailByEnquiryId(params) {
    return request.post(
      `${urlPre}Enquiry/queryEnquiryDetailByEnquiryId`,
      params
    );
  },
  // 查询报价单详情
  querySupplierOfferDetailList(params) {
    return request.post(
      `${urlPre}Enquiry/querySupplierOfferDetailList`,
      params
    );
  },
  // 新增报价单
  addSupplierOffer(params) {
    return request.post(`${urlPre}Enquiry/addSupplierOffer`, params);
  },
  // 公司是否系统集成 融合 中化或者盐湖
  companyWhetherSystemIntegrationByCompanyId(params) {
    return request.post(
      '/api-register/apiUser/companyWhetherSystemIntegrationByCompanyId',
      params,
      {
        preventRepeat: false,
      }
    );
  },
  // 作废接口
  cancelSupplierOffer(params) {
    // Enquiry / cancelSupplierOffer;
    return request.post(`${urlPre}Enquiry/cancelSupplierOffer`, params);
  },
  // 延时接口
  changeSupplierOfferDelay(params) {
    return request.post(`${urlPre}Enquiry/changeSupplierOfferDelay`, params);
  },
  // 判断盐湖计划采购订单
  salkLakeOrder(params) {
    return request.fetch('/api-register/tenant/getCompanyTenantCode', params);
  },

  // 对账单查询 - 企业后台对账单管理
  statementAccountBackPage(params) {
    return request.post(`${urlPre}statementAccount/backPage`, params);
  },
  // 对账单查询 - 供应商确认对账单
  statementAccountSupplierConfirm(params) {
    return request.post(`${urlPre}statementAccount/supplierConfirm`, params);
  },
  // 对账单  对账单详情查询
  statementAccountDetail(params) {
    return request.post('/transaction-center/statementAccount/detail', params);
  },
  // 对账单  供应商确认对账单
  supplierConfirm(params) {
    return request.post(
      '/transaction-center/statementAccount/supplierConfirm',
      params
    );
  },
  // 对账单  供应商支付对账单
  supplierPay(params) {
    return request.post(
      '/transaction-center/statementAccount/supplierPay',
      params
    );
  },
  // 对账单  导出
  exportStatementAccountFromSupplier(params) {
    return request.post(
      '/transaction-center/statementAccount/exportStatementAccountFromSupplier',
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 判断是否开通扫码支付
  queryScanCodeAuthority(params) {
    return request.post('/payment/payAccount/queryScanCodeAuthority', params);
  },
  // 扫码支付 查询所属行业
  queryCpcnCcategory(params) {
    return request.post('/payment/cpcnPayment/queryCpcnCcategory', params);
  },
  // 开通微信 或者 支付宝 权限
  openCodeCollection(params) {
    return request.post('/payment/payAccount/openCodeCollection', params);
  },
  // 查询开通微信 或者 支付宝 状态
  queryScanCodeApplyStatus(params) {
    return request.post('/payment/payAccount/queryScanCodeApplyStatus', params);
  },
  // 磋商报价记录--供应商
  offerConsultSupplierRecord(params) {
    return request.post(
      '/transaction-center/Enquiry/offerConsultSupplierRecord',
      params
    );
  },
  // 磋商报价--供应商
  supplierOfferConsult(params) {
    return request.post(
      '/transaction-center/Enquiry/supplierOfferConsult',
      params
    );
  },

  // 磋商报价记录明细
  offerConsultRecordDetail(params) {
    return request.post(
      '/transaction-center/Enquiry/offerConsultRecordDetail',
      params
    );
  },

  // 报价按钮校验时间
  checkOfferTime(params) {
    return request.post('/transaction-center/Enquiry/checkOfferTime', params);
  },

  // 对账单管理 - 分页查询
  reconciliationPage(params) {
    return request.post('/transaction-center/reconciliation/page', params);
  },
  // 对账单管理 - 对账单列表 - 导出
  exportReconciliation(params) {
    return request.post(
      '/transaction-center/reconciliation/exportReconciliation',
      params,
      { responseType: 'blob' }
    );
  },
  // 对账单管理 - 供应商确认
  reconciliationConfirm(params) {
    return request.post('/transaction-center/reconciliation/confirm', params);
  },
  // 对账单管理 - 详情查询
  reconciliationDetail(params) {
    return request.post('/transaction-center/reconciliation/detail', params);
  },
  // 对账单管理 - 驳回对账单
  rejectStatement(params) {
    return request.post('/transaction-center/statementAccount/reject', params);
  },

  // 对账单管理详情列表 - 导出
  exportReconciliationDetail(params) {
    return request.post(
      '/transaction-center/reconciliationItem/exportReconciliation',
      params,
      {
        responseType: 'blob',
      }
    );
  },
  // 详情列表
  reconciliationItemPage(params) {
    return request.post('/transaction-center/reconciliationItem/page', params);
  },

  // 询比价供应商报价导出商品
  exportEnquiryDetail(params) {
    return request.post(
      '/transaction-center/Enquiry/exportEnquiryDetail',
      params,
      { responseType: 'blob' }
    );
  },
  // 上传报价信息
  batchOfferExcelUpload(params) {
    return request.post(
      '/transaction-center/Enquiry/batchOfferExcelUpload',
      params
    );
  },
  /* downProductList: function(params) {
    return request.post("/product/productExcel/downProductList", params, { responseType: "blob" });
  }, */

  // 询比价黑名单-检验是否在黑名单内(在黑名单内返回true)
  blackCheck(params) {
    return request.post('/user-center/inquiry/blacklist/check', params);
  },
  // 平台黑名单
  blacklistCheck(params) {
    return request.post('/user-center/blacklist/check', params);
  },
  // 获取发货地址列表-分页
  shipQueryPage(params) {
    return request.post('/user-center/address/ship/queryPage', params);
  },
  // 获取发货地址列表-不分页
  shipQueryList(params) {
    return request.post('/user-center/address/ship/queryList', params);
  },

  // 获取资源引入方联系方式
  queryShareContact(params) {
    return request.post(`/product/shareContact/queryShareContact`, params);
  },
  // 获取收费通知书列表
  getChargeNoticeSupplierList(params) {
    return request.post(
      `/transaction-center/chargeNoticeSupplier/page`,
      params
    );
  },
  // 获取收费通知书详情
  getChargeNoticeSupplierDetail(params) {
    return request.post(
      `/transaction-center/chargeNoticeSupplier/detail`,
      params
    );
  },
  // 支付
  chargeNoticePayment(params) {
    return request.post(
      `/transaction-center/chargeNoticeSupplier/payment`,
      params
    );
  },
  // 关联单据列表
  statementAccountList(params) {
    return request.post(
      `/transaction-center/chargeNotice/statementAccountList`,
      params
    );
  },
  // 收费单详情
  checkIsPay(params) {
    return request.post(
      `/transaction-center/chargeNoticeSupplier/checkIsPay`,
      params
    );
  },
  // 企业后台-报价单-导出
  exportOfferInfo(params) {
    return request.post(
      `/transaction-center/exportEnquiry/exportOfferInfo`,
      params,
      { responseType: 'blob' }
    );
  },
  // 企业后台-询比价-导出
  exportEnquiryInfo(params) {
    return request.post(
      `/transaction-center/exportEnquiry/enquiryInfo`,
      params,
      { responseType: 'blob' }
    );
  },
  // 企业后台-询比价-导出
  queryESourceProductList(params) {
    return request.post(
      `/transaction-center/supplier/queryESourceProductList`,
      params
    );
  },

  // 分润管理-分页
  divideProfitPayeeQueryPage(params) {
    return request.post(
      `/transaction-center/divideProfitPayee/queryPage`,
      params
    );
  },
  // 分润管理-统计
  divideProfitPayeeGetCount(params) {
    return request.post(
      `/transaction-center/divideProfitPayee/getCount`,
      params
    );
  },
  // 寻源定制管理 - 分页查询
  sourcingCustomizationSupplierPage(params) {
    return request.post(
      `/transaction-center/sourcingCustomization/supplierPage`,
      params
    );
  },
  // 寻源定制管理 - 供应商详情查询
  supplierDetail(params) {
    return request.post(
      `/transaction-center/sourcingCustomization/supplierDetail`,
      params
    );
  },
  // 寻源定制 - 供应商补充寻源定制
  supplierModify(params) {
    return request.post(
      `/transaction-center/sourcingCustomization/supplierModify`,
      params
    );
  },

  // 订单报表 概要列表  查询操作日志
  orderLogQueryPage(params) {
    return request.post('/transaction-center/orderLog/queryPage', params);
  },
  // 订单报表 概要列表  订单列表
  operatorOrderList(params) {
    return request.post('data-center/dataEnterpriseOrder/orderList', params);
  },
  // 订单报表 订单明细 列表
  orderQueryOrderSkuList(params) {
    return request.post(
      '/data-center/dataEnterpriseOrder/queryOrderSkuList',
      params
    );
  },
  // 导出订单概要
  dataOperationOrderExportOrder(params) {
    return request.post(
      '/data-center/dataEnterpriseOrder/exportOrder',
      params,
      { responseType: 'blob' }
    );
  },
  // 导出订单明细
  exportOrderSkuList(params) {
    return request.post(
      '/data-center/dataEnterpriseOrder/exportOrderSkuList ',
      params,
      { responseType: 'blob' }
    );
  },

  // 订单概要 金额小计
  queryOrderTotalAmount(params) {
    return request.post(
      'data-center/dataEnterpriseOrder/queryOrderTotalAmount',
      params
    );
  },
  // 订单明细 金额小计
  queryOrderSkuTotalAmount(params) {
    return request.post(
      '/data-center/dataEnterpriseOrder/queryOrderSkuTotalAmount',
      params
    );
  },
  // 商品清单
  listSupplierSku(params) {
    return request.post('/transaction-center/orderSku/listSupplierSku', params);
  },

  // 运营中心---查询询价列表
  queryEnquiryListForAdmin(params) {
    return request.post(
      '/transaction-center/EnquiryStatistics/queryEnquiryListForAdmin',
      params
    );
  },
  // 分页----定向询价供应商
  querySupplierListPage(params) {
    return request.post(
      '/transaction-center/Enquiry/querySupplierListPage',
      params
    );
  },
  // 分页----查询报价单详情
  querySupplierOfferDetailPage(params) {
    return request.post(
      '/transaction-center/Enquiry/querySupplierOfferDetailPage',
      params
    );
  },

  queryCurrentCompanySonList(params) {
    return request.post(
      '/user-center/companyHierarchy/queryCurrentCompanySonList',
      params
    );
  },
  queryFirstPartyList(params) {
    return request.post(
      '/user-center/companyHierarchy/queryPurchasersSonList',
      params
    );
  },
  querySupplierList(params) {
    return request.post(
      '/user-center/companyHierarchy/querySupplierSonList',
      params
    );
  },
  // 获取易物流地图url拼接参数token
  getEwuliuMapToken(params) {
    return request.post('/logistics/ewuliu/getToken', params);
  },

  // 采购订单列表调
  purchaseListOrder(params) {
    return request.post(`${urlPre}purchase/listOrder`, params);
  },
  // 历史库存单列表接口/原材料库存单列表
  ecStockQueryPage(params) {
    return request.post(`${urlPre}ecStock/queryPage`, params);
  },
  // 提交接口
  purchasePlanBind(params) {
    return request.post(`${urlPre}ecPurchasePlan/purchasePlanBind`, params);
  },
  // 采购方案列表
  ecPurchasePlanQueryPage(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryPage`, params);
  },
  // 查找采购方案已绑定的采购订单和历史库存单： 入参 purchasePlanId
  queryBind(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryBind`, params);
  },
  orderAttachUpload: `${baseUrl}/cms/cms/orderAttachUpload`,

  // 原材料库存单-新增
  ecStockAdd(params) {
    return request.post(`${urlPre}ecStock/add`, params);
  },
  // 原材料库存单-详情
  ecStockDetail(params) {
    return request.post(`${urlPre}ecStock/detail`, params);
  },
  // 原材料库存单-删除
  ecStockDelete(params) {
    return request.post(`${urlPre}ecStock/delete`, params);
  },
  // 采购方案列表
  queryOptionPage(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryOptionPage`, params);
  },
  // 石化商城订单列表
  mallOrderQueryOptionPage(params) {
    return request.post(`${urlPre}petroMallOrder/queryOptionPage`, params);
  },

  companyQuerySupplier(params) {
    return request.post(`/user-center/company/querySupplier`, params);
  },
  // 查询分供应商（原材料关联订单，只查询生效的）
  queryPageForOrder(params) {
    return request.post(
      `/user-center/subSupplierApply/queryPageForOrder`,
      params
    );
  },

  queryOrderBind(params) {
    return request.post(
      `/transaction-center/ecPurchasePlan/queryOrderBind`,
      params
    );
  },
  petrolMallOrderQueryOrderBind(params) {
    return request.post(
      `/transaction-center/petroMallOrder/queryOrderBind`,
      params
    );
  },
  ecPurchasePlanSkuQueryPage(params) {
    return request.post(
      `/transaction-center/ecPurchasePlanSku/queryPage`,
      params
    );
  },
  petroMallOrderSkuQueryPage(params) {
    return request.post(
      `/transaction-center/petroMallOrderSku/queryPage`,
      params
    );
  },

  parseSkuExcel(params) {
    return request.post(`${urlPre}ecStock/parseSkuExcel`, params);
  },
  queryStockBind(params) {
    return request.post(`${urlPre}bind/queryStockBindEcAndPetro`, params);
  },
  // 库存订单已绑定的采购方案
  ecQueryStockBind(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryStockBind`, params);
  },
  // 库存订单已绑定的石化商城订单
  pmQueryStockBind(params) {
    return request.post(`${urlPre}petroMallOrder/queryStockBind`, params);
  },
  queryTagLabelList: (params) => {
    return request.fetch(
      `/product/productTags/queryTagLabelList?${qs.stringify(params)}`
    );
  },
  ecPurchasePlanModify(params) {
    return request.post(`${urlPre}ecPurchasePlan/modify`, params);
  },
  // 查询库存单关联的采购方案的数量
  bindCount(params) {
    return request.post(`${urlPre}ecStock/bindCount`, params);
  },
  // 原材料订单数量
  countUnLinked(params) {
    return request.post(`${urlPre}ecPurchasePlan/countUnLinked`, params);
  },
  // 原材料订单数量
  modifyAvailable(params) {
    return request.post(`${urlPre}ecPurchasePlan/modifyAvailable`, params);
  },
  // 是现货，查看已关联的供应商及附件
  materialSupplierList(params) {
    return request.post(`${urlPre}ecPurchasePlan/materialSupplierList`, params);
  },
  // 原材料库存单导出
  ecStockExport(params) {
    return request.post(`${urlPre}ecStock/export`, params, {
      responseType: 'blob',
    });
  },
  // 采购方案导出
  ecPurchasePlanExport(params) {
    return request.post(`${urlPre}ecPurchasePlan/export`, params, {
      responseType: 'blob',
    });
  },
  // coco 我的报价列表用这个接口
  queryMySupplierOfferPage(params) {
    return request.post(
      `${urlPre}enquirySupplier/queryMySupplierOfferPage`,
      params
    );
  },
  // 查看是否开通AI审查功能
  queryCompanyOnpenAiReview(params) {
    return request.post(
      `${urlPre}orderConfig/queryCompanyOnpenAiReview`,
      params
    );
  },
  // 历史库存单修改
  ecStockModify(params) {
    return request.post(`${urlPre}ecStock/modify`, params);
  },
  // 石化商城订单-列表
  petroMallOrderPage(params) {
    return request.post(`${urlPre}petroMallOrder/queryPage`, params);
  },
  // 石化商城订单-导出
  petroMallOrderExport(params) {
    return request.post(`${urlPre}petroMallOrder/export`, params, {
      responseType: 'blob',
    });
  },
  // 石化商城订单-导出
  petroMallOrderSkuPage(params) {
    return request.post(`${urlPre}petroMallOrderSku/queryPage`, params);
  },
  // 石化商城订单-原材料供应商及附件  是否现货查看详情
  mallOrderMaterialSupplierList(params) {
    return request.post(`${urlPre}petroMallOrder/materialSupplierList`, params);
  },
  // 石化商城订单-添加备注
  petroMallOrderModify(params) {
    return request.post(`${urlPre}petroMallOrder/modify`, params);
  },
  // 石化商城订单-添加备注
  petroMallOrderQueryBind(params) {
    return request.post(`${urlPre}petroMallOrder/queryBind`, params);
  },
  // 石化商城订单-绑定采购订单/历史库存单/成品现货
  petroMallOrderBind(params) {
    return request.post(`${urlPre}petroMallOrder/petroMallOrderBind`, params);
  },
  // 石化商城订单-待关联 数量
  petrolMallOrderUnLinkedNum(params) {
    return request.post(`${urlPre}petroMallOrder/countUnLinked`, params);
  },
  // 原材料管理查询绑定--订单列表
  queryOrderManageBind(params) {
    return request.post(
      `${urlPre}supplierOrderPurchaseOrder/queryBind`,
      params
    );
  },
  // 原材料管理绑定--订单列表
  orderManageBind(params) {
    return request.post(`${urlPre}supplierOrderPurchaseOrder/bind`, params);
  },
  // 原材料采购订单---石化商城
  pmQueryBindOrder(params) {
    return request.post(`${urlPre}petroMallOrder/queryBindOrder`, params);
  },
  // 库存订单--石化商城
  pmQueryBindStock(params) {
    return request.post(`${urlPre}petroMallOrder/queryBindStock`, params);
  },
  // 成品现货--石化商城
  pmQueryBindAvailable(params) {
    return request.post(`${urlPre}petroMallOrder/materialSupplierList`, params);
  },
  // 原材料详情--石化商城
  pmOrderDetail(params) {
    return request.post(`${urlPre}petroMallOrder/detail`, params);
  },
  // 原材料详情--原材料采购订单
  ecPurchasePlanDetail(params) {
    return request.post(`${urlPre}ecPurchasePlan/detail`, params);
  },
  // 原材料采购订单
  queryBindOrder(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryBindOrder`, params);
  },
  // 库存订单
  queryBindStock(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryBindStock`, params);
  },
  // 成品现货
  queryBindAvailable(params) {
    return request.post(`${urlPre}ecPurchasePlan/queryBindAvailable`, params);
  },
  // AI建议审查结果
  scAiCheckReportById(params) {
    return request.post(`${urlPre}scAiCheck/reportById`, params);
  },
  // AI建议审查 版本
  scAiCheckOption(params) {
    return request.post(`${urlPre}scAiCheck/option`, params);
  },
  // AI保存复核意见
  scAiCheckReviewList(params) {
    return request.post(`${urlPre}scAiCheckReview/list`, params);
  },
  // AI增加复核意见
  scAiCheckReviewAdd(params) {
    return request.post(`${urlPre}scAiCheckReview/add`, params);
  },
  // AI修改复核意见
  scAiCheckReviewModify(params) {
    return request.post(`${urlPre}scAiCheckReview/modify`, params);
  },
  // 查sku已上传的附件
  scSkuAttachQuery(params) {
    return request.post(`${urlPre}scSkuAttach/query`, params);
  },
  // 订单详情附件 上传
  scSkuAttachBatchAttach(params) {
    return request.post(`${urlPre}scSkuAttach/batchAttach`, params);
  },
  // 原材料库存订单 支持上传附件
  modifyAttach(params) {
    return request.post(`${urlPre}ecStock/modifyAttach`, params);
  },
  // 采购意向单-成品现货  ecMaterialSupplier/modifyAttach
  ecMaterialSupplierModifyAttach(params) {
    return request.post(`${urlPre}ecMaterialSupplier/modifyAttach`, params);
  },
  // 石化商城订单-修改原材料供应商的合同、附件 petroMaterialSupplier/modifyAttach
  petroMaterialSupplierModifyAttach(params) {
    return request.post(`${urlPre}petroMaterialSupplier/modifyAttach`, params);
  },
  // 当前供应商是否配置了原材料多级穿透配置
  isRawMaterials(params) {
    return request.post(`/user-center/companyType/isRawMaterials`, params);
  },
  // 石化采购意向单查看成品现货
  ecPurchasePlanMaterialSupplierList(params) {
    return request.post(`${urlPre}ecPurchasePlan/materialSupplierList`, params);
  },

  queryRuleCategoryList(params) {
    return request.post(`${urlPre}petroMallOrder/queryRuleCategoryList`, params);
  },
  ///petroMallOrder/queryRuleCategoryListForStock
  queryRuleCategoryListForStock(params) {
    return request.post(`${urlPre}petroMallOrder/queryRuleCategoryListForStock`, params);
  },


};

export default server;
